jQuery(function () {
    $('[data-password]').each(function () {
        $this = $(this)

        $this
            .parent('div')
            .append(
                '<div data-id="' +
                    $this.attr('id') +
                    '" class="reveal absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 cursor-pointer"><p class="toggleSee mt-5 mb-0 text-gray">Voir</p><p class="toggleHide mt-5 mb-0 text-gray hidden">Cacher</p></div>'
            )
    })

    $('.reveal').on('click', function () {
        $this = $(this)
        $toggleSee = $this.find('.toggleSee')
        $toggleHide = $this.find('.toggleHide')
        $input = $('#' + $this.attr('data-id'))

        if ('password' === $input.attr('type')) {
            $toggleHide.removeClass('hidden')
            $toggleSee.addClass('hidden')
            $input.attr('type', 'text')
        } else {
            $toggleSee.removeClass('hidden')
            $toggleHide.addClass('hidden')
            $input.attr('type', 'password')
        }
    })
})
